module.exports = __webpack_public_path__ + "img/average_engine_rpm.d62081fb.svg";